import { NextRouter } from 'next/router'
import { defaultStudentPage, navigationPush } from '../navigation/studentPages'
import { getUser } from '../requests/studentRequests'
import teacherPages, { defaultTeacherPage } from '../navigation/teacherPages'
import { defaultAdminPage } from '../navigation/adminPages'
import notLoggedInPages from '../navigation/notLoggedInPages'
import {defaultDistrictAdminPage} from '../navigation/districtAdminPages'

const redirectToHomepage = async (router: NextRouter, toTeacherOrientation: boolean = false): Promise<void> => {
  if (!localStorage.getItem('access_token')) {
    navigationPush(notLoggedInPages.signIn.getRoute(), router, notLoggedInPages.signIn.v1)
    return
  }

  try {
    const user = await getUser()
    if (['student', 'personal'].includes(user.role)) {
      navigationPush(defaultStudentPage.route, router, defaultStudentPage.v1)
    } else if (user.role === 'teacher' || user.role === 'school_admin') {
      if (toTeacherOrientation) {
        navigationPush(teacherPages.orientation.getRoute(user.schoolId, user.id), router, teacherPages.orientation.v1)
      } else {
        navigationPush(defaultTeacherPage.getRoute(user.schoolId, user.id), router, defaultTeacherPage.v1)
      }
    } else if (user.role === 'district_admin') {
      navigationPush(defaultDistrictAdminPage.getRoute(user.districtId), router)
    } else if (user.role === 'admin') {
      navigationPush(defaultAdminPage.route, router, defaultAdminPage.v1)
    }
  } catch (e) {
    localStorage.removeItem('access_token')
    navigationPush(notLoggedInPages.signIn.getRoute(), router, notLoggedInPages.signIn.v1)
  }
}

export default redirectToHomepage
